import { SvgIconProps } from '@material-ui/core/SvgIcon';
import * as React from 'react';

function EditBarIcon(props: SvgIconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9325 1.40129C15.5095 0.978217 14.8235 0.978217 14.4005 1.40129L2.4838 13.318C2.28064 13.5211 2.1665 13.7967 2.1665 14.084V18.4173C2.1665 19.0156 2.65153 19.5006 3.24984 19.5006H7.58317C7.87049 19.5006 8.14604 19.3865 8.3492 19.1834L20.2659 7.26668C20.6889 6.84362 20.6889 6.15769 20.2659 5.73462L15.9325 1.40129ZM4.33317 17.334V14.5327L15.1665 3.69938L17.9678 6.50065L7.13444 17.334H4.33317ZM22.7498 22.7507H3.24984C2.65153 22.7507 2.1665 23.2357 2.1665 23.834C2.1665 24.4323 2.65153 24.9173 3.24984 24.9173H22.7498C23.3481 24.9173 23.8332 24.4323 23.8332 23.834C23.8332 23.2357 23.3481 22.7507 22.7498 22.7507Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoEditBarIcon = React.memo(EditBarIcon);
export default MemoEditBarIcon;
